import { createContext } from "react";

export const ScrollElementContext = createContext<HTMLElement | null>(null);
